


















import { Component, Mixins, Prop } from "vue-property-decorator";
import { IInvoice } from "@/models/invoices";
import { IState } from "@/store";
import { mapState } from "vuex";
import { DataModules } from "@/store/modules/data";
import { downloadBlob, convertObjAb2Json } from "@/helpers/file";
import { IShare } from "@/models/share";
import InvoiceProvider from "@/components/app/global/invoices/invoiceProvider.vue";
import PaymentStatusMixin from "@/mixins/paymentStatusMixin";

@Component({
  components: {
    "invoice-pending-payment-msg": () =>
      import("@/components/app/global/invoices/invoicePendingPaymentMsg.vue"),
    "invoice-status-msg": () =>
      import("@/components/app/global/invoices/invoiceStatusMsg.vue"),
    "invoice-details": () =>
      import("@/components/app/global/invoices/invoiceDetails.vue")
  },
  computed: {
    ...mapState({
      countries: (state: IState) => state.constants.countries,
      invoice(): IInvoice {
        return this.shareObject.object;
      }
    })
  }
})
export default class ShareInvoiceView extends Mixins(
  InvoiceProvider,
  PaymentStatusMixin
) {
  // Props
  @Prop({ required: true })
  public token!: string;

  @Prop({ required: true })
  public shareObject!: IShare;

  // Data

  // override
  public async loadData() {
    this.isLoading = false;
    return;
  }

  // override
  public getInvoiceData() {
    return Promise.resolve();
  }

  public get downloadPDFAction() {
    return this.shareObject.actions.find(
      i => i.service === "invoice" && i.method === "download_invoice_pdf"
    );
  }

  public get payAction() {
    return this.shareObject.actions.find(
      i => i.service === "payment" && i.method === "store"
    );
  }

  public async pay() {
    const modal = await this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import(
            "@/components/app/global/payments/sharedInvoicePaymentModal.vue"
          ),
        props: {
          invoice: this.invoice,
          share: this.shareObject
        },
        width: 740,
        events: {
          success: () => {
            modal.close();
            this.$emit("refresh");
          }
        }
      }
    });
  }

  public download() {
    this.$set(this.isProcessing, "download", true);
    this.$store
      .dispatch(`data/${DataModules.SHARES}/getSharedObject`, {
        vm: this,
        storeData: false,
        token: this.token,
        action: `${this.$_.get(
          this.downloadPDFAction,
          "service"
        )}.${this.$_.get(this.downloadPDFAction, "method")}`,
        returnData: false,
        responseType: "arraybuffer"
      })
      .then(data => {
        const blob = new Blob([data], {
          type: "application/pdf;"
        });
        const filename = `${this.$_.get(
          this.shareObject.object,
          "number"
        )}.pdf`;
        downloadBlob(blob, filename);
      })
      .catch(error => {
        // Convert ArrayBuffer data to JSON
        convertObjAb2Json(error, "response.data");
        // Check for 404 (not found)
        if (this.$_.get(error, "response.status") === 404) {
          return this.$store.dispatch("toast/warning", {
            message: this.$t(
              "_sentence.pdf_is_being_generated_and_will_be_available_shortly"
            )
          });
        }
        this.$store.dispatch("api/handleError", error);
      })
      .finally(() => {
        this.$delete(this.isProcessing, "download");
      });
  }
}
